
    import { Component, Vue, Prop, Watch } from "vue-property-decorator";
    // import AssignmentDetail from "./AssignmentDetail.vue";
    import ShiftDetail from "./ShiftDetail.vue";
    import Detail from "./Detail.vue";
    /*import Approval from "./Approval.vue";*/
    import PotentialTrade from "./PotentialTrades.vue";
    import SelfSchedule from './SelfSchedule.vue';
    import Request from './Request.vue';
    import RequestedTrade from "./RequestedTrade.vue";
    import Unavailability from './Unavailability.vue';
    import OpenNeed from './OpenNeed.vue';
    import TradeShift from './TradeShift.vue';
    import { namespace } from "vuex-class";
    import moment from "moment";
    import SymphonyOperatingRooms from './SymphonyOperatingRooms.vue'

    const profile = namespace("profile");
    const schedule = namespace("schedule");
    @Component({
        components: {
            // AssignmentDetail,
            /*Approval,*/
            PotentialTrade,
            Detail,
            ShiftDetail,
            SelfSchedule,
            Request,
            RequestedTrade,
            Unavailability,
            OpenNeed,
            TradeShift,
            SymphonyOperatingRooms
        },
    })
    export default class SharedModal extends Vue {
        @Prop({required: true}) readonly isPanelOpen!: boolean;
        @Prop() sharedRequest: any;
        @Prop() currentEvent: any;
        @Prop() additionalRequestEvent: any;
        @Prop() selectedDate: any;
        @Prop() counter: any;
        @Prop() scheduleStartDate!: Date;
        @Prop() scheduleEndDate!: Date;
        @schedule.State
        public assignmentDetail!: any;
        public selectedDateToCompare!: Date;
        requestTypeArray = ["New Request", "Scheduled Event", "Scheduled Event",  "Scheduled Event"];
        // todo manage this array

        activeTab: number = 10;
        isLoaded: boolean = false;
        singleTab: boolean = false;
        isProductive: boolean = false;

        constructor(props) {
            super(props);
            const sharedRequest = JSON.parse(JSON.stringify(this.$props.sharedRequest));
            delete sharedRequest.type;
            delete sharedRequest.calSelectedDates;
            //const updatedArray = Object.entries(sharedRequest);
            //this.activeTab = Number(
            //    Object.keys(updatedArray).find((key) => {
            //        return updatedArray[key][1];
            //    })
            //);  
            this.activeTab = this.getActiveTab(this.sharedRequest);
            //this.setActiveTab(this.sharedRequest);
            this.selectedDateToCompare = (this.sharedRequest && this.sharedRequest.calSelectedDates && this.sharedRequest.calSelectedDates.startDate ? this.sharedRequest.calSelectedDates.startDate : this.currentEvent.date);
        }  

        @Watch('isPanelOpen', {immediate: true}) onMatchChanged() {
            if(this.isPanelOpen) {
                document.getElementsByClassName('neu-padding--bottom-100')[0].classList.add('postion-relative', 'overflow-hidden');
            } else {
                document.getElementsByClassName('neu-padding--bottom-100')[0].classList.remove('postion-relative', 'overflow-hidden');
            }
        }
        showSuccessModal(flag: boolean = true, msgValue: string = '') {
            this.$emit("showSuccessModal", flag, msgValue);
        }
        compareScheduleStartDate(): boolean {
            return moment(this.selectedDateToCompare).format("MMMM DD, yyyy") === moment(this.scheduleStartDate).format("MMMM DD, yyyy");
        }
        compareScheduleEndDate(): boolean {
            return moment(this.selectedDateToCompare).format("MMMM DD, yyyy") === moment(this.scheduleEndDate).format("MMMM DD, yyyy");
        }
        close() {
            this.$emit("close-modal");
        }
        formatDate(date: Date): string {
            return moment(date).format("MMMM DD, yyyy");
        }
        previousDay() {
            let clickEventNextDate: Date;
            if (this.sharedRequest && this.sharedRequest.calSelectedDates && this.sharedRequest.calSelectedDates.startDate) {
                clickEventNextDate = new Date(this.sharedRequest.calSelectedDates.startDate);
            }
            else {
                clickEventNextDate = new Date(this.currentEvent.date);
            }
            clickEventNextDate.setDate(clickEventNextDate.getDate() - 1);
            this.$emit("raiseClickEvent", clickEventNextDate);
        }
        nextDay() {
            let clickEventNextDate: Date;
            if (this.sharedRequest && this.sharedRequest.calSelectedDates && this.sharedRequest.calSelectedDates.startDate) {
                clickEventNextDate = new Date(this.sharedRequest.calSelectedDates.startDate);
            }
            else {
                clickEventNextDate = new Date(this.currentEvent.date);
            }
            clickEventNextDate.setDate(clickEventNextDate.getDate() + 1);
            this.$emit("raiseClickEvent", clickEventNextDate);            
        }
        showDateNavigation() {
            var startDate: any;
            var endDate: any;
            var ret = true;
            if (this.sharedRequest && this.sharedRequest.calSelectedDates && !this.sharedRequest.availability) {
                startDate = moment(this.sharedRequest.calSelectedDates.startDate).format("MMMM DD, yyyy");
                endDate = moment(this.sharedRequest.calSelectedDates.endDate).add(-1, 'days').format("MMMM DD, yyyy");                
                if (startDate === endDate)
                    ret = true;
                else
                    ret = false;
            }
            return ret;
        }
        getActiveTab(sharedRequest) {
            var activeTab = 10;
            if (sharedRequest.type === 1) {                
                if (sharedRequest.selfSchedule && this.currentEvent.status !='0 Needs') {
                    activeTab = 0;
                }
                else if (sharedRequest.request) {
                    activeTab = 1;
                }
                else if (sharedRequest.availability) {
                    activeTab = 2;
                }
                else if (sharedRequest.vacationBidding) {
                    activeTab = 3;
                }
                else if (sharedRequest.additionalRequest) {
                    activeTab = 4;
                }
                else {
                    activeTab = 5;
                }
            }
            else if (sharedRequest.type === 2) {
                if (sharedRequest.isSymphonyUser) {
                    activeTab = 0;
                } 
                else if (sharedRequest.event) {
                    activeTab = 1;
                }
                else if (sharedRequest.assignmentDetail) {
                    activeTab = 2;
                }
            }
            else if (sharedRequest.type === 4) {
                if (sharedRequest.isSymphonyUser) {
                    activeTab = 0;
                }
                else if (sharedRequest.tradeShift) {
                    activeTab = 1;
                }
                else if (sharedRequest.assignmentDetail) {
                    activeTab = 2;
                } else if(sharedRequest.request){
                    activeTab = 3;
                }
            }
            return activeTab;
        }
    }
